import { useEffect } from "react"

import { GLOBAL_SEARCH_SHORTCUT_KEY } from "shared/constants/app-constants"
import { GLOBAL_SEARCH_OVERLAY } from "shared/context/overlay/types"
import { useEvent } from "shared/lib/useEvent"
import { useOverlay } from "shared/lib/useOverlay"

export function useGlobalSearchKeyboardShortcut() {
  const { isOpen, openOverlay } = useOverlay(GLOBAL_SEARCH_OVERLAY)

  const handleKeyDown = useEvent((event: KeyboardEvent) => {
    if (
      (event.ctrlKey || event.metaKey) &&
      event.key === GLOBAL_SEARCH_SHORTCUT_KEY
    ) {
      if (!isOpen) {
        event.preventDefault()
        openOverlay(null)
      }
    }
  })

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown)
    return () => window.removeEventListener("keydown", handleKeyDown)
  }, [])
}
